<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">امتیازات کسب شده توسط کاربر</h5>
      </div>

      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-md-6">
            <b-form-group label="انتخاب مشتری" class="col-md-12">
              <CustomerSearch
                v-model="selectedCustomer"
                :allow-empty="true"
                :show-label="false"
              />
            </b-form-group>
          </div>
          <div class="col-md-5">
            <button
              :disabled="disabled"
              class="btn btn-primary"
              type="button"
              @click="loadUserPointsList"
            >
              نمایش امتیازات
            </button>
          </div>
        </div>
        <b-table
          :style="{ opacity: disabled ? '0.6' : 1 }"
          bordered
          responsive
          striped
          v-if="items && items.data && items.data.length"
          :fields="fields"
          :items="items.data"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(score_value)="data">
            {{ data.item.score_value | price }}
          </template>
          <template v-slot:cell(bon_value)="data">
            {{ data.item.bon_value | price }}
          </template>
          <template v-slot:cell(cause_title)="data">
            {{ data.item.cause_title }}
          </template>
          <template v-slot:cell(product)="data">
            {{ data.item.product }}
          </template>
          <template v-slot:cell(date)="data">
            {{ data.item.date | Date }}
          </template>
        </b-table>
        <div v-else class="alert alert-info">
          موردی یافت نشد
        </div>
        <pagination
          v-if="items && items.data && items.data.length"
          :disabled="disabled"
          :limit="2"
          :data="items"
          @pagination-change-page="changePage"
        >
        </pagination>
      </div>
    </div>
  </main>
</template>
<script>
import PointsEarnedImpl from "@@/core/pages/customerClub/clubReports/pointsEarned/PointsEarnedImpl.js";
export default {
  extends: PointsEarnedImpl,
};
</script>
